import { MtfElementInput } from '@/types/schema';

export enum MtfComponentActionEnum {
  AddOption = 'ADD_OPTION',
  UpdateOption = 'UPDATE_OPTION',
  RemoveOption = 'REMOVE_OPTION',
  ReorderOption = 'REORDER_OPTION',
}

interface AddOptionAction {
  type: MtfComponentActionEnum.AddOption;
}

export interface UpdateOptionAction {
  type: MtfComponentActionEnum.UpdateOption;
  payload: {
    leftElement?: MtfElementInput;
    rightElement?: MtfElementInput;
    index: number;
  };
}

interface RemoveOptionAction {
  type: MtfComponentActionEnum.RemoveOption;
  payload: {
    index: number;
  };
}

interface ReorderOptionAction {
  type: MtfComponentActionEnum.ReorderOption;
  payload: {
    fromIndex: number;
    toIndex: number;
  };
}

export type QuizOptionsActions =
  | AddOptionAction
  | UpdateOptionAction
  | RemoveOptionAction
  | ReorderOptionAction;

export type onMtfComponentAction = (action: QuizOptionsActions) => void;
